import './App.css';
import Signup from './pages/sign-up/Signup'
import Comingsoon from './pages//coming-soon-page/Comingsoon'


import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
function App() {
  return (
<BrowserRouter>
<Routes>
  <Route path="/Signup" element={<Signup />} />
  <Route path="/" element={<Comingsoon />} />

  
</Routes>
</BrowserRouter>
  );
}

export default App;
